<template>
  <md-app style="min-height: 100vh;">
        <md-app-toolbar class="main-bar" md-elevation="2">
            <span class="md-title">SICSE</span>
        </md-app-toolbar>
        
        <md-app-content>
            <form class="md-layout" @submit.prevent="login">
                <md-card>
                    <md-card-content>
                        <md-field>
                            <label for="usu_login">Nome de usuário</label>
                            <md-input name="usu_login" id="usu_login" v-model="form.usu_login"/>
                        </md-field>

                        <md-field>
                            <label for="password">Senha</label>
                            <md-input type="password" name="password" id="password" v-model="form.password" />
                        </md-field>

                        <md-button type="submit" class="md-raised md-primary">Login</md-button>
                    </md-card-content>
                </md-card>
            </form>

             <md-snackbar md-position="center" :md-duration="20000" :md-active.sync="loginError" md-persistent>
                <span>Nome de usuário ou senha incorretos</span>
            </md-snackbar>
        </md-app-content>
  </md-app>
</template>

<script>
import {auth} from '../services/api'

export default {
    name: 'login',
    data: () => {
        return {
            loginError: false,
            form: {
                usu_login: null,
                password: null
            }
        }
    },
    methods: {
        login() {
            auth(this.form.usu_login, this.form.password).then(() => {
                this.$router.push({ path: '/' })
            }).catch(() => {
                this.loginError = true
            })
        }
    }
}
</script>

<style scoped>
.md-content.md-app-content {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}
.md-layout {
    display: flex;
    flex-wrap: wrap;
    width: 372px;
}
.md-card {
    width: 100%;
    box-shadow: none;
    border: 1px solid #e7e7e7;
}
</style>